/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import AntPath from "../../AntPath/AntPath";
import PolylineArrorw from "../../PolylineDecorator/PolylineArrow";
import L from "leaflet";

import { withTimerangeIntelligence } from "../../../shared/containers/containerTimerangeIntelligence";
import { withMapPositions } from "../../../shared/containers/containerMapPositions";
import { withIntelligenceTimeRangePlayer } from "../../../shared/containers/containerIntelligenceTimeRangePlayer";
import { withSensors } from "../../../shared/containers/containerSensors";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import { withMessages } from "../../../shared/containers/containerMessages";

import MapWrapper from "../../../shared/map/mapWrapper";
import MapMarker from "../../../shared/map/mapMarker";
import MapStartMarker from "../../../shared/map/mapStartMarker";
import MapFinishMarker from "../../../shared/map/mapFinishMarker";
import MapStatusMarker from "../../../shared/map/mapStatusMarker";

import MapPopup from "../../../shared/map/mapPopup";
import { Popup, Polyline, Marker } from "react-leaflet";
import { getCoordinateClick, openPoupup, getDataPoupup } from "../../../services/PoupUpService/poupupService";

import TopRightMapControl from "../../LayerMapCotrol/TopRightMapControl";
import TopLefttMapControl from "../../LayerMapCotrol/TopLeftMapControl";
import GeozoneInfoControl from "../../LayerMapCotrol/GeozoneInfoControl";
import GeozoneEditControl from "../../LayerMapCotrol/GeozoneEditControl";
import LayerMapControl from "../../LayerMapCotrol/LayerMapContol";
import BaseLayerMapControl from "../../LayerMapCotrol/BaseLayerMapControl";
import { states } from "../../../reducers/queriesStates";
import "./../../../shared/map/mapPopup";
import MarkerClusterGroup from "react-leaflet-markercluster";
import "./markerCluster.css";
import VideoPanel from "../../VideoPanel/VideoPanel";
import { withAuth } from "../../../shared/containers/containerAuth";
import SpeedColorControl from "../../LayerMapCotrol/SpeedColorControl";
import { withRouteSpeedColor } from "../../../shared/containers/containerRouteSpeedColor";
import IntelligenceMapSpeedColorRoute from "./IntelligenceMapSpeedColorRoute";
import SearchAddressControl from "../../LayerMapCotrol/SearchAddressControl/SearchAddressControl";
import { withGeocoder } from "../../../shared/containers/containerGeocoder";
import { searchMarkerIconService } from "../../Geocoders/searchMarkerIconService";

require("react-leaflet-markercluster/dist/styles.min.css");

let _zoom = null;
let _mapCenter = null;

class IntelligenceMapInTimeRange extends Component {
  constructor(props) {
    super(props);
    _zoom = props.zoom;
    _mapCenter = props.mapCenter;

    this.getCurrentPoint = this.getCurrentPoint.bind(this);

    this.state = {
      palayerRoutes: [[]],
      pointIndex: 0,
      currentPoint: null,
    };
  }

  componentDidMount() {
    const { isSensorsDataReady } = this.props;

    if (!isSensorsDataReady) this.getSensors();
  }

  componentDidUpdate(prevProps) {
    const {
      carId,
      startDate,
      endDate,
      timerangeIntelligenceState,
      onSetTimeRangeIntelligenceReady,
      onSetTimeRangeIntelligenceFailure,
      mapPositionsDataState,
      onGetMapPositions,
      onGetMessages,
      mapPositionsCount,
      onGetMapParkingPositions,
      onGetMapOrigenalPositions,
      onGetMapFuelingPositions,
      onGetMapDrainPositions,
      onGetMapGpsJammingPositions,
      onGetSpeedingPoints,
      data,
    } = this.props;

    const { sensorsDataState, sensorsData, onSetSensorsDataReady, onSetSensorsDataEmpty, mapPositionsData, onSetMapBounds, mapBounds } =
      this.props;

    if (sensorsDataState === states.READY && prevProps.sensorsDataState === states.REQUEST) {
      if (Object.entries(sensorsData.sensors).length === 0) onSetSensorsDataEmpty();
      else onSetSensorsDataReady();
    }

    if (sensorsDataState === states.NOT_REQUESTED && prevProps.sensorsDataState !== states.NOT_REQUESTED) this.getSensors();

    if (timerangeIntelligenceState === states.REQUEST && prevProps.timerangeIntelligenceState !== states.REQUEST) {
      onGetMapPositions({ carId, startDate, endDate });
      onGetMessages({ carId, startDate, endDate });

      if (data.permissions.includes(11015)) {
        onGetMapOrigenalPositions({ carId, startDate, endDate });
      }

      onGetMapParkingPositions({ carId, startDate, endDate });
      onGetMapFuelingPositions({ carId, startDate, endDate });
      onGetMapDrainPositions({ carId, startDate, endDate });
      onGetMapGpsJammingPositions({ carId, startDate, endDate });
      onGetSpeedingPoints({ carId, startDate, endDate });
    }

    if (mapPositionsDataState === states.READY && prevProps.mapPositionsDataState === states.REQUEST) {
      if (timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceReady();
      }
    }

    if (mapPositionsDataState === states.FAILURE && prevProps.mapPositionsDataState === states.REQUEST) {
      if (timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceFailure();
      }
    }

    if (mapPositionsDataState === states.READY && prevProps.mapPositionsDataState === states.REQUEST) {
      if (mapPositionsCount > 0) {
        const latLngs = mapPositionsData
          .filter((item) => {
            return item.location.lat !== 0;
          })
          .map((item) => L.latLng([item.location.lat, item.location.long]));

        if (latLngs.length > 0) {
          onSetMapBounds(new L.latLngBounds(latLngs));
        }
      }

      if (mapPositionsCount === 0 && timerangeIntelligenceState === states.REQUEST) {
        onSetTimeRangeIntelligenceFailure();
      }
    }

    if (mapPositionsDataState === states.READY && prevProps.mapPositionsDataState === states.READY && mapBounds !== null) {
      onSetMapBounds(null);
    }

    const { currentPointIndex, mapRoutes, isPlay } = this.props;
    const { pointIndex, palayerRoutes } = this.state;

    if (isPlay && pointIndex !== currentPointIndex) {
      palayerRoutes[0] =
        palayerRoutes > pointIndex
          ? palayerRoutes[0].concat(mapRoutes[0][currentPointIndex])
          : mapRoutes[0].filter((x, index) => {
              return index < currentPointIndex;
            });

      this.setState({ pointIndex: currentPointIndex, palayerRoutes: palayerRoutes });
    }

    /*  if (!isPlay && palayerRoutes[0].length > 0) {
      this.setState({ palayerRoutes: [[]] });
    } */
  }

  componentWillUnmount() {
    const { onSetZoom, onSetMapCenter } = this.props;

    onSetMapCenter(_mapCenter);
  }

  getSensors() {
    const { match, onGetSensors } = this.props;

    let date = new Date();
    date.setSeconds(0);

    onGetSensors(match.params.id, date);
  }

  getCurrentPoint(data) {
    const { currentPointIndex } = this.props;

    const currentPoint = data.find((item) => {
      if (!!item.finishIndex) return currentPointIndex >= item.index && currentPointIndex <= item.finishIndex;
      else return currentPointIndex === item.index;
    });

    return !!currentPoint ? currentPoint : data[data.length - 1];
  }

  getAntPathOptions(dalay, dassArray, weight, color, opacity, pulseColor) {
    return {
      delay: dalay,
      dashArray: dassArray,
      weight: weight,
      color: color,
      opacity: opacity,
      pulseColor: pulseColor,
      hardwareAccelerated: true,
    };
  }

  getRouteOptions(i) {
    return this.getAntPathOptions(1000, [30, 200], 3, i % 2 ? "#fc0317" : "#3388ff", 1, "#FFFFFF");
  }

  getPlayerRouteOptions(i) {
    return this.getAntPathOptions(1000, [30, 200], 3, "#05611e", 1, "#FFFFFF");
  }

  getOrigenalPointsOptions() {
    return this.getAntPathOptions(1000, [30, 200], 3, "#025709", 1, "#FFFFFF");
  }

  getDumpRouteOptions() {
    return this.getAntPathOptions(2000, [30, 200], 3, "#000000", 1, "#FFFFFF");
  }

  getDump2RouteOptions() {
    return this.getAntPathOptions(2000, [30, 200], 7, "#41b671ff", 1, "#FFFFFF");
  }

  getSandRouteOptions() {
    return this.getAntPathOptions(2000, [30, 200], 10, "#df8d21ff", 1, "#FFFFFF");
  }

  getMapStatusMarker(item, status) {
    const position = [item.location.coordinates[1], item.location.coordinates[0]];

    return (
      <MapStatusMarker position={position} status={status} key={item.id}>
        <MapPopup startTime={item.timeStart} finishTime={item.timeEnd} status={status} address={item.location.address} />
      </MapStatusMarker>
    );
  }

  getStopMarkers(parkings) {
    return parkings.map((item) => {
      return this.getMapStatusMarker(item, 0);
    });
  }

  getFuelingDrtainMarker(events, status) {
    return events.map((item) => {
      const position = [item.location.coordinates[1], item.location.coordinates[0]];

      return (
        <MapStatusMarker position={position} status={status} key={item.id}>
          <MapPopup startTime={item.timeAction} status={status} address={item.location.address} info={"Литры"} value={item.value} />
        </MapStatusMarker>
      );
    });
  }

  getGpsJammingMarker(events, status) {
    return events.map((item) => {
      const position = [item.location.coordinates[1], item.location.coordinates[0]];

      return (
        <MapStatusMarker position={position} status={status} key={item.id}>
          <MapPopup
            startTime={item.timeStart}
            status={status}
            address={item.location.address}
            info={"Длительность"}
            value={item.duration}
          />
        </MapStatusMarker>
      );
    });
  }

  getSpeedingPointsMarker(events, status) {
    return events.map((item) => {
      const position = [item.location.coordinates[1], item.location.coordinates[0]];

      return (
        <MapStatusMarker position={position} status={status} key={item.id}>
          <MapPopup startTime={item.time} status={status} address={item.location.address} info={"Скорость"} value={item.speed} />
        </MapStatusMarker>
      );
    });
  }

  handlePoupup(origenal, currentPoint, e) {
    if (!currentPoint) {
      const coordinate = getCoordinateClick(e, this.props.mapPoints);
      const { mapPoints, match, origenalPositions } = this.props;

      openPoupup(
        e.target,
        coordinate !== null ? coordinate : e.latlng,
        origenal ? origenalPositions : mapPoints,
        match.params.id,
        coordinate.distance,
      );
    } else {
      const { match } = this.props;

      getDataPoupup(e.target, match.params.id, currentPoint);
    }
  }

  handlePoupupArrow(e) {
    const { match, mapPoints } = this.props;

    const coordinate = getCoordinateClick(e, mapPoints);

    openPoupup(e.target, coordinate !== null ? coordinate : e.latlng, mapPoints, match.params.id, coordinate.distance);
  }

  onEnd(e) {
    try {
      _zoom = e.sourceTarget._zoom;
      _mapCenter = e.sourceTarget.getCenter();
    } catch {}
  }

  render() {
    const {
      sensorsData,
      mapRoutes,
      mapPoints,
      parkings,
      fuelings,
      drains,
      origenalPositions,
      match,
      mapBaseLayer,
      zoom,
      sandRoutes,
      dumpRoutes,
      dump2Routes,
      gpsJammings,
      speedingPoints,
      routeSpeedColor,
      searchMapMarkerLocation,
      dataSearch,
    } = this.props;

    const {
      viewAnimation,
      viewRoute,
      viewOrigenalPositions,
      viewStopMarker,
      viewFuelingMarker,
      viewDrainMarker,
      viewGpsJammingMarker,
      viewSpeedingPointsMarker,
      viewStartFinishMarker,
      viewPosition,
      viewDump,
      viewDump2,
      viewSand,
    } = this.props.mapOverlayers;

    let currentPoint = this.getCurrentPoint(mapPoints);

    if (currentPoint === undefined || currentPoint === null) {
      currentPoint = {
        location: [sensorsData.location.lat, sensorsData.location.long],
        status: sensorsData.state.status,
        number: sensorsData.number,
        date: sensorsData.date,
      };
    }

    const startPoint = mapPoints.length > 0 ? mapPoints[0] : null;
    const finishPoint = mapPoints.length > 0 ? mapPoints[mapPoints.length - 1] : null;

    const { palayerRoutes } = this.state;

    const getIconSearch = (color) => {
      return L.divIcon({
        html: `<div>${searchMarkerIconService.getSeachIcon(color)}</div>`,
        className: "svg-icon",
        iconSize: [60, 60],
        iconAnchor: [30, 60],
      });
    };

    return (
      <div>
        <MapWrapper
          position={currentPoint.location}
          onEnd={this.onEnd.bind(this)}
          key={currentPoint.number + mapBaseLayer.name + zoom + sensorsData.location.lat + sensorsData.location.long}
        >
          {!!mapRoutes ? (
            <div>
              {viewStartFinishMarker && startPoint !== null ? (
                <div>
                  <MapStartMarker position={startPoint.location} onClick={this.handlePoupup.bind(this, false, null)} />
                  <MapFinishMarker position={finishPoint.location} onClick={this.handlePoupup.bind(this, false, null)} />
                </div>
              ) : null}

              <MarkerClusterGroup showCoverageOnHover={false} maxClusterRadius={10} iconCreateFunction={createClusterCustomIcon}>
                {viewStopMarker ? this.getStopMarkers(parkings) : null}
                {viewFuelingMarker ? this.getFuelingDrtainMarker(fuelings, 3) : null}
                {viewDrainMarker ? this.getFuelingDrtainMarker(drains, 4) : null}
                {viewGpsJammingMarker ? this.getGpsJammingMarker(gpsJammings, 5) : null}
                {viewSpeedingPointsMarker ? this.getSpeedingPointsMarker(speedingPoints, 6) : null}
              </MarkerClusterGroup>
            </div>
          ) : null}

          <div>
            {!routeSpeedColor.isOn ? (
              <div>
                {mapRoutes.map((x, i) => {
                  if (!viewAnimation) {
                    const color = i % 2 ? "#fc0317" : "#3388ff";

                    return (
                      <div key={i + "route" + viewRoute + "" + routeSpeedColor.isOn}>
                        <PolylineArrorw polyline={x} isView={viewRoute} isArrowPolyyline={i + "route"} />
                        {viewRoute ? (
                          <Polyline
                            pathOptions={{ color }}
                            positions={x}
                            eventHandlers={{
                              click: this.handlePoupupArrow.bind(this),
                            }}
                          >
                            <Popup className="mapPopup" />
                          </Polyline>
                        ) : null}
                      </div>
                    );
                  }

                  return (
                    <div key={i + "route" + viewRoute + "" + routeSpeedColor.isOn}>
                      {viewRoute ? (
                        <AntPath
                          positions={x}
                          options={this.getRouteOptions(i)}
                          eventHandlers={{
                            click: this.handlePoupup.bind(this, false, null),
                          }}
                        >
                          <Popup className="mapPopup" />
                        </AntPath>
                      ) : null}

                      <PolylineArrorw polyline={x} isView={false} isArrowPolyyline={i + "route"} />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div>
                {mapRoutes.map((x, i) => {
                  return <PolylineArrorw polyline={x} isView={false} isArrowPolyyline={i + "route"} />;
                })}

                <IntelligenceMapSpeedColorRoute
                  handlePoupup={this.handlePoupup.bind(this, false, null)}
                  handlePoupupArrow={this.handlePoupup.bind(this, false, null)}
                />
              </div>
            )}

            <div>
              {palayerRoutes[0].length > 1 ? (
                <div>
                  {viewAnimation ? (
                    <AntPath
                      positions={palayerRoutes}
                      options={this.getPlayerRouteOptions()}
                      eventHandlers={{
                        click: this.handlePoupup.bind(this, false, null),
                      }}
                    >
                      <Popup className="mapPopup" />
                    </AntPath>
                  ) : (
                    <Polyline
                      key={palayerRoutes[0].length}
                      pathOptions={{ color: "#05611e" }}
                      positions={palayerRoutes}
                      eventHandlers={{
                        click: this.handlePoupupArrow.bind(this),
                      }}
                    >
                      <Popup className="mapPopup" />
                    </Polyline>
                  )}
                </div>
              ) : null}
            </div>

            <div>
              {!!sandRoutes && viewSand
                ? sandRoutes
                    .filter((x) => {
                      return x.length > 1;
                    })
                    .map((x, i) => {
                      return (
                        <div key={i}>
                          {viewAnimation ? (
                            <AntPath
                              positions={x}
                              options={this.getSandRouteOptions()}
                              eventHandlers={{
                                click: this.handlePoupup.bind(this, false, null),
                              }}
                            >
                              <Popup className="mapPopup" />
                            </AntPath>
                          ) : (
                            <Polyline
                              pathOptions={{ weight: 10, color: "#df8d21ff" }}
                              positions={x}
                              eventHandlers={{
                                click: this.handlePoupupArrow.bind(this),
                              }}
                            >
                              <Popup className="mapPopup" />
                            </Polyline>
                          )}
                        </div>
                      );
                    })
                : null}
            </div>

            <div>
              {!!dumpRoutes && viewDump
                ? dumpRoutes
                    .filter((x) => {
                      return x.length > 1;
                    })
                    .map((x, i) => {
                      return (
                        <div key={i}>
                          {viewAnimation ? (
                            <AntPath
                              positions={x}
                              options={this.getDumpRouteOptions()}
                              eventHandlers={{
                                click: this.handlePoupup.bind(this, false, null),
                              }}
                            >
                              <Popup className="mapPopup" />
                            </AntPath>
                          ) : (
                            <Polyline
                              pathOptions={{ color: "#000000" }}
                              positions={x}
                              eventHandlers={{
                                click: this.handlePoupupArrow.bind(this),
                              }}
                            >
                              <Popup className="mapPopup" />
                            </Polyline>
                          )}
                        </div>
                      );
                    })
                : null}
            </div>

            <div>
              {!!dump2Routes && viewDump2
                ? dump2Routes
                    .filter((x) => {
                      return x.length > 1;
                    })
                    .map((x, i) => {
                      return (
                        <div key={i}>
                          {viewAnimation ? (
                            <AntPath
                              positions={x}
                              options={this.getDump2RouteOptions()}
                              eventHandlers={{
                                click: this.handlePoupup.bind(this, false, null),
                              }}
                            >
                              <Popup className="mapPopup" />
                            </AntPath>
                          ) : (
                            <Polyline
                              pathOptions={{ color: "#41b671ff" }}
                              positions={x}
                              eventHandlers={{
                                click: this.handlePoupupArrow.bind(this),
                              }}
                            >
                              <Popup className="mapPopup" />
                            </Polyline>
                          )}
                        </div>
                      );
                    })
                : null}
            </div>

            {origenalPositions.length > 0 && viewOrigenalPositions ? (
              <AntPath
                positions={origenalPositions.map((position) => {
                  return [position.location.lat, position.location.long];
                })}
                options={this.getOrigenalPointsOptions()}
                eventHandlers={{
                  click: this.handlePoupup.bind(this, true, null),
                }}
              >
                <Popup className="mapPopup" />
              </AntPath>
            ) : null}
          </div>

          {viewPosition ? (
            <MapMarker
              key={sensorsData.location.lat + sensorsData.location.long}
              position={currentPoint.location}
              status={currentPoint.status}
              number={sensorsData.number}
              onClick={this.handlePoupup.bind(this, false, currentPoint)}
            />
          ) : null}
          <GeozoneEditControl carId={match.params.id} />

          {searchMapMarkerLocation !== null && dataSearch !== null ? (
            <Marker
              key={`${searchMapMarkerLocation.lat} ${searchMapMarkerLocation.lon}`}
              position={[searchMapMarkerLocation.lat, searchMapMarkerLocation.lon]}
              icon={getIconSearch("red")}
            >
              <Popup className="mapPopup">{dataSearch}</Popup>
            </Marker>
          ) : null}
        </MapWrapper>

        <TopRightMapControl top="40px">
          <LayerMapControl />
          <BaseLayerMapControl />
          <SpeedColorControl />
        </TopRightMapControl>

        <TopLefttMapControl>
          <SearchAddressControl />
        </TopLefttMapControl>

        <TopLefttMapControl>
          <GeozoneInfoControl />
        </TopLefttMapControl>

        <TopLefttMapControl>
          <VideoPanel />
        </TopLefttMapControl>
      </div>
    );
  }
}

const createClusterCustomIcon = function (cluster) {
  const markers = cluster.getAllChildMarkers();
  let status = "middle";

  const isStrong = markers.some((x) => {
    return x.options.status === 4 || x.options.status === 3;
  });

  if (isStrong) {
    status = "strong";
  } else if (
    markers.some((x) => {
      return x.options.status === 5;
    })
  ) {
    status = "jamming";
  }

  const isSpeedingPoints = markers.some((x) => {
    return x.options.status === 6;
  });

  if (isSpeedingPoints) {
    status = "speedingPoints";
  }

  return L.divIcon({
    html: `<div ><span class="marker-cluster-number">${cluster.getChildCount()}</span></div>`,
    className: `marker-cluster-${status}`,
    iconSize: L.point(25, 25, true),
  });
};

export default withGeocoder(
  withRouteSpeedColor(
    withAuth(
      withMapControl(
        withMessages(
          withIntelligenceTimeRangePlayer(withMapPositions(withSensors(withTimerangeIntelligence(React.memo(IntelligenceMapInTimeRange))))),
        ),
      ),
    ),
  ),
);
